import React from "react";
import UserComponent from "../../components/mosaic/Users";

const UsersPage: React.FC = () => {
  return <UserComponent />;
};

export default UsersPage;
